import { OnInit, AfterViewInit, EventEmitter, ElementRef } from '@angular/core';
import { AlertService } from '../../../services';
var UvsityModalPopup = /** @class */ (function () {
    function UvsityModalPopup(alertService) {
        this.alertService = alertService;
        this.isModalDialogToBeDisplayed = false;
        this.isSignUp = false;
        this.pleaseWait = false;
        this.messageTitle = "Info!!";
        this.messages = [""];
        this.uvsityModalPopupClosed = new EventEmitter();
        this.popupWidthPercentage = "30%";
        this.isValidationError = false;
        this.modalDialogStyle = "position: fixed; height: auto; width: " + this.popupWidthPercentage + "; top: auto; left: 801px; display: none;";
    }
    UvsityModalPopup.prototype.ngOnInit = function () {
        var _this = this;
        this.modalDialogStyle = "position: fixed; height: auto; width: " + this.popupWidthPercentage + "; top: auto; left: 801px; display: none;";
        console.log("The isValidationError in the modal dialog is ==>" + this.isValidationError);
        this.alertSubscription = this.alertService.getMessage().subscribe(function (message) {
            if (message != null && message.text) {
                if (message.text == 'Focus on Close Button') {
                    _this.focusCloseButton();
                }
            }
        });
    };
    UvsityModalPopup.prototype.ngOnDestroy = function () {
        if (!this.alertSubscription.closed) {
            this.alertSubscription.unsubscribe();
        }
    };
    UvsityModalPopup.prototype.ngAfterViewInit = function () {
    };
    UvsityModalPopup.prototype.showModalDialog = function () {
        if (this.isModalDialogToBeDisplayed === true) {
            return "block";
        }
        else {
            return "none";
        }
    };
    UvsityModalPopup.prototype.focusCloseButton = function () {
        if (this.isValidationError == true) {
            console.log("Before seting focus on close button validation error div");
            if (document.getElementById("valDiv") != null) {
                document.getElementById("valDiv").style.display = "block";
                document.getElementById("valDiv").focus();
            }
            console.log("Finished seting focus on close button validation error div");
        }
    };
    UvsityModalPopup.prototype.handleModalPopupClose = function () {
        this.isModalDialogToBeDisplayed = false;
        this.uvsityModalPopupClosed.emit("uvsityModalPopupClosed");
    };
    UvsityModalPopup.prototype.handleEscape = function () {
        if (this.isModalDialogToBeDisplayed == true) {
            this.handleModalPopupClose();
        }
    };
    return UvsityModalPopup;
}());
export { UvsityModalPopup };
//# sourceMappingURL=modaldialog.component.js.map